/**
 * Firebase web app config for Catch'n'Merge (client-side; safe to embed in bundles).
 */
export const firebaseConfig = {
  apiKey: "AIzaSyBFVHbhXxs5ye2sD3CUsq1muP-K18e680Q",
  authDomain: "catch-n-merge.firebaseapp.com",
  databaseURL: "https://catch-n-merge-default-rtdb.firebaseio.com",
  projectId: "catch-n-merge",
  storageBucket: "catch-n-merge.firebasestorage.app",
  messagingSenderId: "975834102185",
  appId: "1:975834102185:web:053bcbb3f423e8df1a2cb8",
};

if (import.meta.env.VITE_WITH_FRVR !== "true") {
  firebaseConfig.measurementId = "G-C3Q5HNPR1E";
}
